import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { Check, X } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("missing"); return; }
    let attempts = 0;
    const maxAttempts = 15;
    const interval = 800; // 800ms between polls — usually paid by attempt 1-2
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts++ < maxAttempts) setTimeout(poll, interval);
        else setStatus("pending");
      } catch {
        if (attempts++ < maxAttempts) setTimeout(poll, interval);
        else setStatus("error");
      }
    };
    poll();
     
  }, [sessionId]);

  return (
    <div data-testid="checkout-success-page" className="bg-ink text-white pt-32 pb-24 min-h-screen">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {status === "paid" ? (
          <div data-testid="checkout-paid">
            <span className="inline-grid place-items-center h-16 w-16 border-2 border-adrenaline text-adrenaline mb-6"><Check size={32} /></span>
            <h1 className="text-display text-6xl uppercase leading-none">Drop Secured</h1>
            <p className="text-zinc-400 mt-6">Your order is locked in. Confirmation coming to your inbox.</p>
            <div className="mt-4 text-mono text-sm text-zinc-300">Total: ${(info?.amount_total / 100 || 0).toFixed(2)} {info?.currency?.toUpperCase()}</div>
          </div>
        ) : status === "checking" || status === "pending" ? (
          <div>
            <div className="h-2 w-32 mx-auto bg-adrenaline animate-pulse-red" />
            <h1 className="text-display text-5xl uppercase leading-none mt-8">Verifying Payment…</h1>
            <p className="text-zinc-500 text-mono text-xs uppercase tracking-widest mt-6">Hold tight. Don't refresh.</p>
          </div>
        ) : (
          <div>
            <span className="inline-grid place-items-center h-16 w-16 border-2 border-adrenaline text-adrenaline mb-6"><X size={32} /></span>
            <h1 className="text-display text-5xl uppercase leading-none">Checkout Issue</h1>
            <p className="text-zinc-400 mt-6">Payment could not be confirmed. If you were charged, contact <span className="text-white">support@lonestarspeedco.com</span>.</p>
          </div>
        )}
        <Link to="/" className="mt-12 inline-block text-heading uppercase tracking-[0.2em] text-sm border-b border-white pb-1 hover:text-adrenaline">Back Home →</Link>
      </div>
    </div>
  );
}
